/**
 * @returns language only language code ex. ja, en, de, fr
 * @param languageCode with specific by region ex. ja, en, de, fr, en-US, en-GB, ja-JP
 */
export const getLanguageLocale = (languageCode: string) => {
  return languageCode.split('-')[0];
};
